import React, { useContext, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import apiClient from '../services/apiClient';
import { EinstellungenKontext, EinstLink } from './einstellungen/EinstLink';
import { persoenlicheAdresse } from './einstellungen/seiten';
import { PRAEFERENZEN_TEXTE as T, WEBSUCHE_ANKER, type PraeferenzenStand } from './einstellungen/praeferenzen';

// F-23 (Nutzerblick Mitglied H-01, Schwere 3): wer die Websuche an hat, liest am Eingabefeld, dass Suchbegriffe an Google gehen.
// Was gilt, sagt GET /api/auth/preferences (Firmensperre, Recherche-Art); in einer Sicht liest die Oberfläche nichts (403).
// Neu gelesen wird, sobald keine Bereichsseite mehr offen ist: die App bleibt dahinter gemountet (F-19).

/** Ist die Websuche für die nächste Recherche wirksam an? Ohne Antwort, bei Fehler und in einer Sicht false. */
export function useWebsucheAn(): boolean {
  const { user } = useAuth();
  const { offen } = useContext(EinstellungenKontext);
  const sicht = !!user?.sicht?.aktiv;
  const [an, setAn] = useState(false);
  useEffect(() => {
    if (sicht || offen || !user) { if (sicht || !user) setAn(false); return; }
    let aus = false;
    apiClient.get<PraeferenzenStand>('/api/auth/preferences')
      .then(antwort => { if (!aus) setAn(antwort.data.recherche.websucheSchaltbar && antwort.data.webSearch.wirksam); }, () => { if (!aus) setAn(false); });
    return () => { aus = true; };
  }, [sicht, offen, user?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  return an;
}

/** Der Satz mit dem Weg in die Präferenzen; der Aufrufer zeigt ihn nur, wenn useWebsucheAn() true ist. */
export function WebsucheHinweis({ id, className }: { id?: string; className?: string }) {
  return <p id={id} className={className} data-websuche>
    {T.websucheHinweis}{' '}
    <EinstLink to={`${persoenlicheAdresse('praeferenzen')}#${WEBSUCHE_ANKER}`}>{T.websucheHinweisLink}</EinstLink>
  </p>;
}
